<div class="row">
  <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
    <h3>Receiving Hours</h3>
    <div style="margin-top:10px;">
      <span class="activeSeason"
        *ngIf="fromModule=='reserveContact' || fromModule=='reservation-overview'">{{activeSeasonId}} formula
        reservation</span>
      <span class="activeSeason activeSeasonOnsn" *ngIf="fromModule=='onsnModule'">For {{activeSeasonId}}
        Reservation</span>
        <span class="recevingSubSection" *ngIf="fromModule=='onsnModule' && !editMode">Please indicate the hours your location
          is available to receive and handle vaccine shipments, even if they differ from your business hours.
          Note that on temperature-control product, missed deliveries could result in items that are no longer viable.</span>
    </div>
  </div>

  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" *ngIf="!disableEdit">
    <a (click)="editAction('open')" *ngIf="!editMode"
      style="background: url('../../../../assets/icons/{{baseSiteId}}/editIcon.png') 2px 3px/30% no-repeat padding-box"
      class="editIcon">Edit
    </a>
  </div>
</div>
<div class="row" [ngStyle]="{'padding': '0 15px'}">
  <div class="notes" *ngIf="editMode && fromModule != 'waitlist'">
    <span class="rcvngHrsHeading">Please indicate the hours your location
      is available to receive and
      handle vaccine shipments, even if they differ from your business hours.
      Note that on temperature-control product, missed deliveries could result
      in items that are no longer viable.</span>
    <p class="notes">Carrier delivery hours are from 8:00 am to 8:00 pm</p>
  </div>

  <!-- <div class="notes" *ngIf="!editMode && fromModule != 'waitlist'">
    <span class="rcvngHrsHeading">Please indicate the hours your location
      is available to receive and
      handle vaccine shipments, even if they differ from your business hours.
      Note that on temperature-control product, missed deliveries could result
      in items that are no longer viable.</span>
    <p class="notes"  *ngIf="fromModule !='onsnModule'">Carrier delivery hours are from 8:00 am to 8:00 pm</p>
  </div> -->

  <div class="notesBlack" *ngIf="editMode && fromModule == 'waitlist'">
    <span>Please indicate the hours your location is available to receive and
      handle vaccine shipments, even if they differ from your business hours.
      Note that on temperature-control product, missed deliveries could result
      in items that are no longer viable.</span>
    <p class="notes">Carrier delivery hours are from 8:00 am to 8:00 pm</p>
  </div>

  <div
    [ngClass]="{'mb-3 fs-16': fromModule == 'reservation-overview', 'notesBlack': fromModule != 'reservation-overview'}"
    *ngIf="(!editMode && fromModule == 'waitlist') || (!editMode && fromModule == 'reservation-overview')">
    <span>Please indicate the hours your location is available to receive and
      handle vaccine shipments, even if they differ from your business hours.
      Note that on temperature-control product, missed deliveries could result
      in items that are no longer viable.</span>
  </div>
</div>
<section class="col-xs-12 col-sm-12 col-md-12" [ngClass]="fullWidth == 'True' ? 'col-lg-12' : 'col-lg-8'"
  *ngIf="(!editMode && showTimings) || editMode;else noData">
  <ng-container *ngFor="let item of deliveryHours; let i = index">
    <div class="row deliveryDate" tabindex="-1" (click)="
        showFromTimeList = false;
        showFromTimeListFor = null;
        showToTimeList = false;
        showToTimeListFor = null
      ">
      <div class="warning" *ngIf="showErrorFor == i">
        <img src="../../../../assets/icons/{{baseSiteId}}/warning_red_new.png" alt="" />
        To-time should be greater than from-time.
      </div>
      <label class="deliveryDay col-md-3 col-sm-2 col-xs-2" [ngClass]="fullWidth == 'True' ? 'col-lg-4' : 'col-lg-3'">{{
        item["day"] }}</label>
      <label class="deliveryTimings col-md-9 col-xs-7" *ngIf="!editMode"
        [ngClass]="fullWidth == 'True' ? 'col-lg-8' : 'col-lg-9 '">{{ item["fromTime"]
        }}<span *ngIf="item.fromTime !== '24 hours' && item.fromTime !== 'Closed'">
          - {{ item["toTime"] }}
        </span></label>

      <input type="text" *ngIf="editMode" [ngClass]="
          fullWidth == 'True' ? 'inpTimingCtrlsAside' : 'inpTimingCtrls'
        " id="fromTime{{ i }}" readonly value="{{ item.fromTime }}" placeholder="Set Time" (click)="
          showFromTimeList = true;
          showFromTimeListFor = i;
          showToTimeList = false;
          showToTimeListFor = null;
          $event.stopPropagation()
        " />

      <div class="dropDownPanel fromTimePanel" *ngIf="showFromTimeList && showFromTimeListFor == i">
        <ng-container *ngFor="let opt of timings; let j = index">
          <div id="fromTimeOption-{{ j }}" class="option {{baseSiteId}}" [ngClass]="{ selected: opt == item.fromTime }"
            (click)="
              selectedTime($event.target.textContent, item.day, 'fromTime', j);
              $event.stopPropagation()
            ">
            {{ opt }}
          </div>
        </ng-container>
      </div>

      <span class="col-md-2 col-sm-2 col-xs-2 spanMobileMargin" [ngClass]="fullWidth == 'True' ? 'col-lg-1' : 'col-lg-2'"
        *ngIf="editMode">to</span>

      <input type="text" *ngIf="editMode" [ngClass]="
          fullWidth == 'True' ? 'inpTimingCtrlsAside' : 'inpTimingCtrls'
        " id="toTime{{ i }}" readonly [disabled]="['24 hours', 'Closed'].includes(item.toTime)" value="{{
          !item.hasOwnProperty('toTime')
            ? (item['toTime'] = '24 hours')
            : item.toTime
        }}" placeholder="Set Time" (click)="
          showToTimeList = true; showToTimeListFor = i; showFromTimeList = false; showFromTimeListFor = null; $event.stopPropagation()
        " />

      <div class="dropDownPanel toTimePanel" *ngIf="showToTimeList && showToTimeListFor == i">
        <ng-container *ngFor="let opt of timings; let j = index">
          <div id="toTimeOption-{{ j }}" class="option" [ngClass]="{ selected: opt == item.toTime }" (click)="
              selectedTime($event.target.textContent, item.day, 'toTime', i)
            ">
            {{ opt }}
          </div>
        </ng-container>
      </div>

      <div class="w-100"></div>
      <div class="col-sm-11 error" *ngIf="editMode && showRequiredErrorFor.includes(i) && !item.toTime">
        This field is required
      </div>
    </div>
  </ng-container>
  <div class="col-sm-11" [ngStyle]="{'color': '#ca0000'}" *ngIf="editMode && closedOnAllDays">
    Please select delivery hours at least for one day
  </div>
  <div class="row buttons-row" *ngIf="editMode && !hideBtns">
    <button type="button" class="btn-secondary mr-3" (click)="editAction('close')">
      Cancel
    </button>
    <button type="submit" class="btn-primary" (click)="updateTimings()">
      Update
    </button>
  </div>
</section>

<ng-template #noData>
  <h4 [ngStyle]="{'font': '14px LexendDeca-Regular'}">No data to display</h4>
</ng-template>